import React from "react";
import { Box, IconButton } from "@mui/material";
import VideoCallIcon from "@assets/icons/videoCallIcon";
import AudioCallIcon from "@assets/icons/audioCallIcon";
import {useDispatch} from "react-redux";
import {AppDispatch} from "@store/store";
import {initiateCall} from "@store/callSlice";

interface AudioAndVideoCallProps {
  customStatus: string;
  ticketId: string | undefined;
}
 
const AudioAndVideoCall: React.FC<AudioAndVideoCallProps> = ({
                                                                 customStatus,
                                                                 ticketId,
                                                             }) => {

    const dispatch = useDispatch<AppDispatch>();
    const handleCall = (isVideoOn: boolean) => {
        console.log("isVideoOn", isVideoOn, ticketId)
        dispatch(
            initiateCall({
                ticketId: ticketId,
                hasVideo: isVideoOn,
                startCall: true
            })
        );
    };

    if (customStatus === "Closed") return <></>;

    return (
        <Box className="flex gap-3 sm:gap-4">
            <IconButton className="cursor-pointer" onClick={() => handleCall(true)}>
                <VideoCallIcon/>
            </IconButton>
            <IconButton className="cursor-pointer" onClick={() => handleCall(false)}>
                <AudioCallIcon/>
            </IconButton>
        </Box>
    );
};
 
export default AudioAndVideoCall;